export default __webpack_public_path__ + "static/media/hht1_ep15_book_wp_02.35a985c1.jpg";